<template>
  <section
    class="dashboard-view relative overflow-hidden"
    :class="{ mobile: getIsMobile, 'is-open': isCollapse }"
    :style="dashboardBackgroundStyle"
  >
    <!-- Background decorations -->
    <div class="absolute -top-36 -left-36 !z-[-1]">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -right-36 -top-36 !z-[-1]">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -bottom-40 -right-40 !z-[-1]">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -bottom-44 -left-44 !z-[-1]">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>

    <!-- Topbar always at the top -->
    <div class="topbar-wrapper" v-if="getIsTopBarVisible">
      <TopbarDefault @open:sidebar="sidebarOpen" />
    </div>

    <!-- Main flex layout: sidebar + main content -->
    <div class="main-flex-layout">
      <!-- Sidebar: always present, collapsible/overlay on mobile -->
      <SidebarDefault
        v-if="!isHorMenu && getIsSideBarVisible"
        :open="sidebarStatus"
        class="sidebar-default"
        :class="{
          'sidebar-collapsed': !getIsOpen,
          'sidebar-mobile': getIsMobile,
          'sidebar-visible': sidebarVisibility,
        }"
      />

      <!-- Main content area -->
      <div class="main-content-area">
        <!-- Optional horizontal menu -->
        <HorizontalMenu v-if="isHorMenu && !getIsMobile && getIsSideBarVisible" />
        <main
          :class="[
            !isHorMenu
              ? 'main-dashboard-view main-dashboard-view-with-sidebar'
              : 'main-dashboard-view-with-horizontal-menu main-dashboard-view-with-horizontal-menu-applied',
            '!bg-container-background',
            '!p-0',
          ]"
          id="MainLayout"
        >
          <router-view :layout.sync="layout" />
        </main>
      </div>
    </div>

    <!-- Overlay for mobile sidebar -->
    <div v-if="getIsMobile && getIsOpen" class="bg-canvas" @click="closeLeftSideBar()"></div>

    <!-- Privacy Link Drawer -->
    <el-drawer
      title="Privacy Link"
      :visible.sync="copyModal"
      :direction="'rtl'"
      :with-header="true"
      :size="getIsMobile ? '50%' : '20%'"
    >
      <div style="padding: 15px">
        <span>Link Name</span>
        <el-input v-model="linkName" placeholder="Enter the Link name"></el-input>
        <span>choose the link type</span>
        <el-card style="width: 100%; height: 50px; display: flex; align-items: center">
          <br />
          <el-radio-group v-model="link" style="margin-bottom: 20px">
            <el-row>
              <el-radio label="PUBLIC"></el-radio>
              <el-radio label="PRIVATE"></el-radio>
            </el-row>
          </el-radio-group>
        </el-card>
        <div style="margin-left: 30px" class="mt-1">
          <el-button
            type="danger"
            icon="el-icon-link"
            class="copy-btn"
            @click="generateLink()"
            :disabled="!linkName || !link"
          >
            Generate Link
          </el-button>
        </div>
        <div v-if="link == 'Public'"></div>
        <div v-if="inputFlag">
          <div style="display: flex" class="mt-1">
            <el-input
              size="mini"
              v-model="generatedLink"
              ref="privateLinkRef"
              v-on:focus="$event.target.select()"
            ></el-input>
            <el-button
              type="danger"
              icon="el-icon-copy-document"
              class="copy-btn"
              size="mini"
              @click="copyLinkToClipboard('privateLinkRef')"
            ></el-button>
          </div>
        </div>
        <div class="mt-1">
          <p style="margin-bottom: 8px; font-style: bold">Existing link</p>
          <div v-for="(link, index) in getIframeUrLinks" :key="index">
            <el-row class="mt-1">
              <el-col :span="10">
                <p>
                  {{ getIframeUrLinks[index].linkName }}
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :content="getIframeUrLinks[index].url_type"
                  >
                    <i class="el-icon-info" slot="reference"></i>
                  </el-popover>
                </p>
              </el-col>
              <el-col :span="5" style="text-align: right">
                <el-button
                  type="danger"
                  icon="el-icon-link"
                  class="copy-btn"
                  size="mini"
                  @click="generateExistLink(link)"
                  style="float: right; margin-left: 10px"
                ></el-button>
              </el-col>
              <el-col :span="5" style="text-align: right">
                <el-switch
                  v-model="getIframeUrLinks[index].status"
                  :active-value="'ACTIVE'"
                  :inactive-value="'INACTIVE'"
                  active-color="var(--brand-500)"
                  inactive-color="var(--black-200)"
                  @change="statusChanged(link)"
                ></el-switch>
              </el-col>
              <el-col :span="4">
                <el-link
                  style="float: right !important"
                  class="mr-1 ml-1"
                  type="danger"
                  :underline="false"
                  @click="onDelete(link)"
                >
                  <i class="el-icon-delete"></i>
                </el-link>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- Footer for mobile -->
    <FooterDefault v-if="getIsMobile" />

    <!-- Internal Chat -->
    <keep-alive>
      <InternalChat v-if="getAuthenticatedUser && getStatusOfInternalChat && showChat" />
    </keep-alive>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TopbarDefault from '../layouts/TopbarDefault';
  import SidebarDefault from '../layouts/SidebarDefault';
  import HorizontalMenu from '../layouts/HorizontalMenu';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';
  import appConfig from '@/config/app';
  import FooterDefault from '../layouts/FooterDefault';
  import InternalChat from '../components/InternalChat.vue';
  import { postAPICall } from '@/helpers/httpHelper';
  export default {
    name: 'home',
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      // this.$router.listen((newLocation) => {console.log(newLocation);})
      // console.log(this.$route);
      if (this.getIsMobile) {
        this.$store.commit('navigationOpen/setIsOpen', false, {
          root: true,
        });
      }
    },
    components: {
      TopbarDefault,
      SidebarDefault,
      HorizontalMenu,
      FooterDefault,
      InternalChat,
    },
    mixins: [MobileRelatedHelper],
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser']),
      ...mapGetters('theme', ['getCurrentTheme', 'getThemeType']),
      ...mapGetters('navigationOpen', ['getIsSideBarVisible', 'getIsTopBarVisible']),
      isMobile() {
        return window.innerWidth <= 768;
      },
      computedCanvasStyle() {
        if (this.$route.path.startsWith('/apps')) {
          return { marginLeft: '0' };
        }
        if (this.getIsMobile) {
          return { marginLeft: '0' };
        } else if (this.getIsOpen) {
          return { marginLeft: '11rem', position: 'relative' };
        } else {
          return { marginLeft: '4rem' };
        }
      },
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('menuManagementV2', [
        'getMenu',
        'getMenuManagementAddStatus',
        'getMenuManagementUpdateStatus',
      ]),
      ...mapGetters('auth', [
        'getActiveWorkspace',
        'getAuthenticationDetails',
        'getAuthenticatedSSOToken',
        'getUserTypeList',
      ]),
      ...mapGetters('company', ['getContactLoginSlug', 'getUpdateCompany', 'getCompanyDetails']),
      ...mapGetters('sso', ['getAuthenticatedSSOToken']),
      ...mapGetters('iFrame', ['getIframeData', 'getIframeUrLinks']),
      ...mapGetters('theme', ['getCurrentTheme', 'getThemeType']),
      isCollapse: {
        get() {
          return this.getIsOpen;
        },
        set(isCollapse) {
          this.$store.commit('navigationOpen/setIsOpen', isCollapse, {
            root: true,
          });
        },
      },
      getLabel() {
        return (userType) => {
          if (userType && userType.role) {
            return userType.role.title + ' - ' + userType.name;
          } else {
            return userType.name;
          }
        };
      },
      showChat() {
        return this.$route.matched.some((r) => r.meta.showChat);
      },
      dashboardBackgroundStyle() {
        // const themeType = this.getThemeType || this.themeType;
        const themeType = this.getThemeType;

        switch (themeType) {
          case 'solid':
            return {
              backgroundColor: 'var(--page-background)', // Use --page-background for solid color
            };
          case 'transparent':
            return {
              backgroundColor: 'var(--page-background)', // Fully transparent background
            };
          case 'solid_gradient':
            return {
              background: `linear-gradient(55deg, var(--primary-color-brand) 0%, var(--brand-100) 50%, var(--primary-color-brand) 100%)`,
            };
          default:
            return {
              backgroundColor: 'var(--page-background)', // Fallback to solid
            };
        }
      },

      primaryBrandColor() {
        // Get the current --color-primary-brand from the theme or CSS variable
        let color = this.getCurrentTheme && this.getCurrentTheme['--color-primary-brand'];
        if (!color) {
          // fallback to CSS variable if not in Vuex
          color = getComputedStyle(document.documentElement)
            .getPropertyValue('--color-primary-brand')
            .trim();
        }
        return color || '#178a7c';
      },
    },
    async mounted() {
      this.fetchBotInfo();

      await this.getCompanyInfo();
      this.getMenuType();
      if (this.$route.name === 'ExpirePage' || this.$route.name === 'Plans') {
        this.sidebarVisibility = false;
      }
    },
    data() {
      return {
        getStatusOfInternalChat: false,
        sidebarVisibility: true,
        layout: 'div',
        offCanvas: true,
        sidebarStatus: false,
        windowWidth: 1500,
        isHorMenu: false,
        copyModal: false,
        getlink: '',
        activeTab: 'first',
        publicLink: '',
        privateLink: '',
        isChecked: false,
        link: '',
        dashboard_role: [],
        inputFlag: false,
        generatedLink: '',
        existedLink: '',
        comparedUrlData: {},
        linkName: '',
        toggle: true,
        themeType: 'Transparent',
      };
    },
    methods: {
      showSidebar() {
        return this.sidebarVisibility && !this.$route.path.startsWith('/apps');
      },
      async fetchBotInfo() {
        this.loading = true;
        try {
          const response = await postAPICall('GET', '/bot/get-Bot');

          // Set internal chat status
          const enabled = !!response?.data?.internal_chat_enabled;
          this.getStatusOfInternalChat = enabled;
          localStorage.setItem('internal_chat_enabled', String(enabled));

          // Extract botId and token if chatBotDetails present
          const botAccounts = response?.data?.chatBotDetails || '';
          const botIdMatch = botAccounts.match(/botId: '(.*?)'/);
          const tokenMatch = botAccounts.match(/token: '(.*?)'/);

          if (botIdMatch && tokenMatch) {
            this.botId = botIdMatch[1];
            this.token = tokenMatch[1];
            localStorage.setItem('botId', this.botId);
            localStorage.setItem('token', this.token);

            if (this.botId && this.token) {
              window.bus.$emit('chatbot');
            } else {
              console.error('Failed to store botId or token in localStorage.');
            }
          }
        } catch (err) {
          console.warn('Failed to fetch bot info', err);
          this.getStatusOfInternalChat = false;
          localStorage.setItem('internal_chat_enabled', 'false');
        } finally {
          this.loading = false;
        }
      },
      async currentThemeColor() {
        return await this.getCurrentTheme['--color-primary-brand'];
      },
      async getCompanyInfo() {
        // this.loading = true;
        try {
          if (
            this.getActiveWorkspace?.company_id !== this.getCompanyDetails?._id ||
            !this.getCompanyDetails?._id
          ) {
            await this.$store.dispatch('company/fetchCompany', this.getActiveWorkspace.company_id);
            if (this.getCompanyDetails) {
              this.loading = false;
              this.brandingInfo = { ...this.getCompanyDetails };
            }
          } else {
            this.brandingInfo = { ...this.getCompanyDetails };
          }
        } catch (e) {
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: e,
          });
        }
      },
      sidebarOpen(status) {
        this.sidebarStatus = status;
      },
      closeLeftSideBar() {
        this.$store.commit('navigationOpen/setIsOpen', false, {
          root: true,
        });
      },
      getMenuType() {
        if (
          this.getCompanyDetails &&
          this.getCompanyDetails.menuType &&
          this.getCompanyDetails.menuType == 'Horizontal'
        ) {
          this.isHorMenu = true;
        } else {
          this.isHormenu = false;
        }
      },
      async openViewConfigPage() {
        let url_key = this.generateOutputFromUrl(this.$route.fullPath, ['key', 'page', 'pageSize']);
        let params = {
          url_key: url_key,
          company_id: this.getActiveWorkspace.company_id,
        };
        await this.$store.dispatch('iFrame/fetchIframeUrlLinks', params);
        this.copyModal = true;
        this.generatedLink = '';
        this.link = '';
        this.linkName = '';
      },
      generateOutputFromUrl(url, excludedKeys = []) {
        let urlParts = url.split('?');
        let path = urlParts[0];
        let queryParams = urlParts.length > 1 ? urlParts[1].split('&') : [];
        let pathSegments = path.split('/');
        let keyValuePairs = {};
        queryParams.forEach((param) => {
          let [key, value] = param.split('=');
          if (!excludedKeys.includes(key)) {
            keyValuePairs[key] = value;
          }
        });
        let output = '';

        pathSegments.forEach((segment, index) => {
          if (index !== 0 && index !== 1) {
            output += `#${segment}`;
          } else {
            output += segment;
          }
        });
        for (const [key, value] of Object.entries(keyValuePairs)) {
          output += `#${key}=${value}`;
        }
        return output;
      },
      generateExistLink(item) {
        let url = appConfig.APP_URL;
        this.existedLink = `${url}/if/${item._id}${item.path}`;
        const tempInput = document.createElement('textarea');
        tempInput.value = this.existedLink;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        this.$message.success('Link copied to clipboard');
      },
      async statusChanged(link) {
        let params = {
          id: link._id,
          status: link.status,
        };
        await this.$store.dispatch('iFrame/updateIframeUrlStatus', params);
      },
      onDelete(link) {
        this.$confirm('Are you sure to delete the link?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.deleteURL(link);
        });
      },
      async deleteURL(link) {
        let params = {
          id: link._id,
        };
        await this.$store.dispatch('iFrame/deleteIframeUrl', params);
        this.openViewConfigPage();
      },
      copyLinkToClipboard(refName) {
        this.$refs[refName].focus();
        document.execCommand('copy');
        this.$message.success('Link copied to clipboard');
      },
      async generateLink() {
        if (this.getAuthenticatedSSOToken) {
          if (this.linkName && this.link) {
            let queryParams =
              Object.keys(this.$route.query).length > 0
                ? `?${new URLSearchParams(this.$route.query).toString()}`
                : '';
            let path = this.$route.path + queryParams;
            let url_key = this.generateOutputFromUrl(this.$route.fullPath, [
              'key',
              'page',
              'pageSize',
            ]);
            let payload = {
              url_type: this.link,
              token: this.getAuthenticatedSSOToken,
              path: path,
              url_key: url_key,
              linkName: this.linkName,
            };
            this.inputFlag = true;
            await this.$store.dispatch('iFrame/addIframe', payload);
            let url = appConfig.APP_URL;
            this.generatedLink = `${url}/${this.getIframeData.link}`;
          } else {
            this.$message.error('Please enter the Link name and choose the link type.');
          }
        } else {
          this.$message.error('To generate a link, please log in through Nimble SSO.');
        }
      },
    },
    watch: {
      link(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.generatedLink = '';
        }
      },
      '$route.name'(newName) {
        if (newName === 'ExpirePage' || newName === 'Plans') {
          this.sidebarVisibility = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  body {
    background: var(--brand-500) !important;
  }
  .dashboard-view {
    min-height: 100vh;
    z-index: 0;
    background-color: var(--page-background);
    display: flex;
    flex-direction: column;

    .topbar-wrapper {
      width: 100%;
      z-index: 100;
      position: relative;
    }

    .main-flex-layout {
      display: flex;
      flex: 1 1 0%;
      min-height: 0;
      position: relative;
      width: 100%;
      overflow: hidden;
    }

    .sidebar-default {
      width: 240px;
      min-width: 60px;
      max-width: 240px;
      transition: width 0.2s;
      z-index: 101;
      background: var(--sidebar-background, #fff);
      // height: calc(100vh - 60px);
      position: relative;

      @media (max-width: 768px) {
        position: fixed;
        left: 0;
        top: 60px;
        // height: calc(100vh - 60px);
        z-index: 2000;
        transform: translateX(-100%);

        &.sidebar-visible {
          transform: translateX(0);
          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
        }
      }

      &.sidebar-collapsed {
        width: 60px;
        min-width: 60px;
        max-width: 60px;
      }
    }

    .main-content-area {
      flex: 1 1 0%;
      min-width: 0;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;

      @media (max-width: 768px) {
        margin-left: 0;
      }
    }

    .main-dashboard-view {
      margin-top: 50px;
      border-radius: 12px;
      min-height: calc(100vh - 70px);

      @media (max-width: 768px) {
        margin-top: 50px;
        padding-left: 8px;
        padding-right: 8px;
        min-height: calc(100vh - 120px);
      }
    }

    .main-dashboard-view-with-horizontal-menu {
      margin-top: 50px;
      border-radius: 12px;

      @media (max-width: 768px) {
        margin-top: 50px;
        padding-left: 8px;
        padding-right: 8px;
        min-height: calc(100vh - 120px);
      }
    }

    .main-dashboard-view-with-sidebar {
      margin-top: 55px !important;
      padding-top: 15px !important;
      padding-left: 20px !important;
      padding-right: 12px !important;

      @media (max-width: 768px) {
        margin-top: 50px !important;
        padding-left: 8px !important;
        margin-inline: 8px !important;
        padding-right: 8px !important;
      }
    }

    .main-dashboard-view-with-horizontal-menu-applied {
      margin-top: 100px !important;
      padding-top: 15px !important;
      padding-left: 20px !important;
      padding-right: 12px !important;

      @media (max-width: 768px) {
        margin-top: 50px !important;
        padding-left: 8px !important;
        margin-inline: 8px !important;
        padding-right: 8px !important;
      }
    }

    .bg-canvas {
      background: rgba(0, 0, 0, 0.5);
      z-index: 1999;
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      display: block;
    }
  }

  .el-drawer__header {
    margin-bottom: 1px;
    padding: 20px 20px 0;
  }
</style>
